function makeChatAccount(state, name) {
  let accs = state.onlineAccounts;
  if (!(name in accs)) {
    return {};
  }

  let onlineAccount = accs[name];
  if (onlineAccount.status !== 'in game') {
    // only valid for in game accounts
    return {};
  }

  let automationState = state.accounts_automation_state[name];

  let unread = name in state.numUnread ? state.numUnread[name] : 0;
  let res = {
    'app': onlineAccount.app,
    'displayID': onlineAccount.displayID,
    'clubID': onlineAccount.entered_clubID,
    'gameType': onlineAccount.chat_view.game_type,

    'automationState': automationState,

    'unread': unread,

     // old stuff
    'name': name,
    'online_acc': onlineAccount,
  };

  let keys = [
      'gave_warning',
      'warned_again',
      'break',
      'snoozed',
      'priming',
      'buyin_state',
      'operator_dont_want_to_leave',
      'contacting_host',
      'contacting_host_not_available',
      'contacting_host_users',
      'claimed',
      'claimed_user_id',
      'available_bankroll',
      'operator_needs_help',
      'is_typing',
      'asked_to_wait_paused_table_until_ts',

      'tourney_states',

      // tech stuff
      'trainer_version',
  ];

  for (let key of keys) {
    res[key] = onlineAccount[key];
  }

  return res;
}


function updateBotState(state, data) {
  if (!data || !data.state || !data.state.room_id) {
    return;
  }
  state.states[data.displayID] = data.state;

  // ! set room queue info by player
  if (data.room_state) {
    state.roomQueue[data.displayID] = data.room_state.room_queue;
    if (data.room_state.room_queue) {
      state.roomQueue[data.displayID].queue_status = data.room_state.queue_status;
    }
  }
}

export { updateBotState, makeChatAccount };
